/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-15 08:18:35 */

const Keys = {
  overview: 'overview',
  location: 'location',
  accommodation: 'accommodation',
  includedServices: 'includedServices',
  show_more: 'show_more',
  show_less: 'show_less'
}; export default Keys;